<ng-container>
  <h4 [title]="item().title | trans" class="solution-title">
    {{ item().title | trans }}
  </h4>

  <span [title]="item().category?.title | trans" class="solution-category">
    {{ item().category?.title | trans }}
  </span>

  <img [alt]="item().title | trans" [src]="getImg()" />

  <div [renderHtml]="item().shortDescription" class="solution-text"></div>

  <a
    [title]="'See more' | trans"
    class="solution-cta"
    [routerLink]="['/solutions', item().category?.slug, item().slug]"
  >
    {{ 'See more' | trans }}
  </a>
</ng-container>
